module.exports = __webpack_public_path__ + "img/model-meg-talking.2039b82f.gif";